import type { UpsellBanner } from '@brighterly/lib-core-types/upsell/interfaces'

import { useKidStore } from '@entities/customer'
import { useCsRoutes } from '@shared/api'

import { useUpsellBannerStore } from './store'

interface UpsellBannerApiReturn {
  fetchUpsellBanner: () => Promise<void>
}

export const useUpsellBannerApi = (): UpsellBannerApiReturn => {
  const { $axios } = useNuxtApp()
  const kidStore = useKidStore()
  const upsellBannerStore = useUpsellBannerStore()

  const fetchUpsellBanner = async (): Promise<void> => {
    const kidId = kidStore.activeKidId
    if (!kidId) {
      console.warn('missing kidId for upsell-banner/upsell-banner.hook.ts')
      upsellBannerStore.setBanner(null)
      return
    }

    const url = useCsRoutes('kids.upsell-banner', {
      '[kid_id]': kidId,
    })

    if (!url) {
      console.warn('missing url for upsell-banner/upsell-banner.hook.ts')
      upsellBannerStore.setBanner(null)
      return
    }

    try {
      upsellBannerStore.setLoading(true)
      const { data } = await $axios.get(url)

      const banner: UpsellBanner | null = data?.success ? (data?.data ?? null) : null
      upsellBannerStore.setBanner(banner)
    } catch (err) {
      console.error('unable to retrieve upsell-banner/upsell-banner.hook.ts:', err)
      upsellBannerStore.setBanner(null)
    } finally {
      upsellBannerStore.setLoading(false)
    }
  }

  return { fetchUpsellBanner }
}
